// Segment 1 — Base Camp
const SCHEDULE = [
  { time: '11:00', id: 1, title: 'Base Camp',            duration: '~13 min' },
  { time: '11:15', id: 2, title: 'Trail Markers',        duration: '10 min'  },
  { time: '11:25', id: 3, title: 'The Briefing',         duration: '10 min'  },
  { time: '11:35', id: 4, title: 'Gear Check',           duration: '8 min'   },
  { time: '11:45', id: 5, title: 'Prompt School',        duration: '34 min'  },
  { time: '12:20', id: 6, title: 'The Build',            duration: '46 min'  },
  { time: '1:10',  id: 7, title: 'The Exchange',         duration: '6 min'   },
  { time: '1:20',  id: 8, title: 'Show & Tell',          duration: '15 min'  },
  { time: '1:40',  id: 9, title: 'The Sustainable Stack',duration: '6 min'   },
];

const Segment1 = () => (
  <div>
    <h1 className="text-4xl md:text-5xl font-bold text-ink mb-6 leading-tight">Base Camp</h1>

    <p className="text-xl md:text-2xl text-ink leading-relaxed mb-12 max-w-lg">
      Welcome to the AI Lab. Six organizations. Thirty builders.
      Three hours. Real tools shipped.
    </p>

    <h2 className="text-xs font-bold uppercase tracking-widest text-ink-muted mb-4">
      Today's Trail
    </h2>

    <div className="space-y-2 max-w-xl" data-testid="schedule-list">
      {SCHEDULE.map((item) => (
        <div
          key={item.id}
          data-testid={`schedule-item-${item.id}`}
          className={`flex items-center gap-4 px-5 py-3.5 rounded-xl ${
            item.id === 1
              ? 'bg-ink'
              : 'bg-white'
          }`}
        >
          <span
            className={`text-sm font-mono font-bold tabular-nums w-12 shrink-0 ${
              item.id === 1 ? 'text-white/60' : 'text-ink-muted'
            }`}
          >
            {item.time}
          </span>
          <span
            className={`text-sm font-semibold flex-1 ${
              item.id === 1 ? 'text-white' : 'text-ink'
            }`}
          >
            {item.title}
          </span>
          <span className={`text-xs ${item.id === 1 ? 'text-white/40' : 'text-ink-muted'}`}>
            {item.duration}
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default Segment1;
